import { Component } from '@angular/core';

@Component({
  selector: 'app-ag-tooltip-cell',
  imports: [],
  templateUrl: './ag-tooltip-cell.component.html',
  styleUrl: './ag-tooltip-cell.component.scss'
})
export class AgTooltipCellComponent {
  value: string = '';

  agInit(params: any): void {
    this.value = params.value ?? '';
  }

  refresh(): boolean {
    return false;
  }
}
